<template>
  <div>
    <my-head></my-head>
    <div style="border-top: #e5e6eb solid 1px; width: 100%"></div>

    <div class="ji_gou flex-center-end" v-show="jgId">
      <cooperation-card :cWidth="'80%'" :cData="jgObj" class="ji_gou_1"></cooperation-card>
    </div>

    <div class="seemore minH">
      <div class="searchs" v-show="!jgId">
        <div class="tabs flex-left">
          <div @click="tab = 1" :class="tab == 1 ? 'checked' : ''">
            专利项目
            <div style="width: 100%" v-show="tab == 1" class="flex-center">
              <img src="../assets/Polygon 1.png" />
            </div>
          </div>
          <div @click="tab = 2" :class="tab == 2 ? 'checked' : ''">
            服务机构
            <div style="width: 100%" v-show="tab == 2" class="flex-center">
              <img src="../assets/Polygon 1.png" />
            </div>
          </div>
        </div>
        <div class="sou_suo flex-left-center">
          <!-- <input
            type="text"
            placeholder="请输入关键字，例如：专利、外观"
            v-model="input1"
          /> -->
          <el-input placeholder="请输入关键字,例如:专利,外观" class="input-with-select" v-model="input1" :validate-event="false"
            @input="(e) => (input1 = $validForbid(e))">
          </el-input>

          <img src="../assets/search.png" style="width: 28px; margin-left: 18px; cursor: pointer" alt=""
            @click="searchInput1" />
        </div>
      </div>

      <div class="crumbs" v-show="!jgId">
        首页 > 交易服务 >
        <span style="color: #1d2129">交易详情</span>
      </div>

      <div class="shai_xuan">
        <div class="title">筛选条件</div>
        <div class="cad flex-left" v-for="(item, index) in shaiXuanList" :key="index">
          <div class="name flex-end-center">{{ item.title }}</div>
          <div class="flex-left flex-wrap" style="flex: 1">
            <div class="col" v-for="(n, i) in item.list" :key="i"
              :class="(item.multi ? (item.col || []).includes(n) : item.col == n) ? 'checked' : ''"
              @click="toggleFilter(item, n)">
              {{ n }}
            </div>

            <div v-if="item.title == '挂牌时间' && (item.col == '自定义' || (Array.isArray(item.col) && item.col.includes('自定义')))">
              <el-date-picker v-model="time1" size="small" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="timestamp">
              </el-date-picker>
            </div>

            <div v-else-if="item.title == '挂牌价格' && (item.col == '自定义' || (Array.isArray(item.col) && item.col.includes('自定义')))">
              <el-input style="width: 100px" size="small" v-model="price1"
                v-on:input="price1 = price1.replace(/[^\d.]/gi, '')"></el-input>
              万元 -
              <el-input style="width: 100px" size="small" v-model="price2"
                v-on:input="price2 = price2.replace(/[^\d.]/gi, '')"></el-input>
              万元
            </div>
          </div>
        </div>
        <div class="flex-center" style="margin-top: 20px">
          <el-button type="primary" @click="patentList">确定筛选</el-button>
        </div>
      </div>

      <!-- <div class="shou_qi flex-center">
        <img src="../assets/Subtract.png" />
        <div class="flex-center">收起</div>
      </div> -->

      <div class="jie_guo flex-between">
        <div>
          为你找到
          <span>{{ total }}</span>
          条相关结果
        </div>
        <!-- <el-select v-model="optionsvalue" placeholder="请选择" size="small">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
      </div>

      <div class="lie_biao flex-between-left flex-wrap" v-if="introduction.length > 0">
        <!-- 父组件传参 -->
        <list-card :obj="item" :tj="input1" v-for="(item, index) in introduction" :key="index"></list-card>
        <div style="width: 31%"></div>
      </div>

      <div class="flex-center fen_ye">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="page.page" :page-size="page.size" layout="prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

      <div class="tui_jian flex-between" v-show="!jgId">
        <div class="name">活跃企业</div>
        <!-- <router-link class="cha_kan" to="/partners">查看全部</router-link> -->
      </div>

      <div class="tui_jian_2 flex-between" v-show="!jgId">
        <div class="zuo flex-center" @click="cardsZ">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="cards">
          <div class="flex-left-center" :style="`transition: all 0.5s;width:${jgList.length * cardwidth
            }px;margin-left:${cardsleft}px;`">
            <cooperation-card class="cards_col" v-for="(item, index) in jgList" :key="index"
              :cData="item"></cooperation-card>
          </div>
        </div>
        <div class="you flex-center" @click="cardsY">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../components/MyHead.vue";
import MyFooter from "../components/MyFooter.vue";
import ListCard from "../components/ListCard.vue";
import CooperationCard from "../components/CooperationCard.vue";
import { getRequest } from "../api/api";
import { mapPropertyCategoryForRequest } from "../api/util";

export default {
  name: "seemore",
  components: {
    MyHead,
    MyFooter,
    ListCard,
    CooperationCard,
  },
  data() {
    return {
      introduction: [],
      tab: 1,
      shaiXuanList: [
        {
          title: "产权类型",
          list: [
            "全部",
            "专利",
            "商业秘密",
            "商标",
            "版权",
            "集成电路",
            "其他",
          ],
          col: ["全部"],
          multi: true,
        },
        {
          title: "项目领域",
          list: [
            "全部",
            "生物医药",
            "先进制造",
            "新材料",
            "新能源",
            "农业科技",
            "人工智能",
            "航空航天",
            "信息技术",
            "集成电路",
            "其他",
          ],
          col: ["全部"],
          multi: true,
        },
        {
          title: "交易类型",
          list: ["全部", "转让", "许可", "作价投资", "其他"],
          col: ["全部"],
          multi: true,
        },
        {
          title: "挂牌时间",
          list: ["全部", "一周内", "一月内", "自定义"],
          col: "全部",
        },
        {
          title: "挂牌价格",
          list: ["不限", "从高到低", "从低到高", "自定义"],
          col: "不限",
        },
      ],
      options: [
        {
          value: "0",
          label: "综合排序",
        },
        {
          value: "选项1",
          label: "选项1",
        },
        {
          value: "选项2",
          label: "选项2",
        },
        {
          value: "选项3",
          label: "选项3",
        },
        {
          value: "选项4",
          label: "选项4",
        },
      ],
      optionsvalue: "0",
      cardsleft: 0,
      cardwidth: 450,
      page: {
        page: 1,
        size: 12,
      },
      total: 0,
      input1: "", //搜索框
      time1: [], //筛选时间自定义
      price1: "", //筛选价格自定义1
      price2: "", //筛选价格自定义2
      jgId: null, //当前是否为机构项目列表,有值就是
      jgList: [], //活跃企业列表
      jgObj: [], //机构详情
    };
  },
  watch: {
    page: {
      handler(newName, oldName) {
        this.patentList();
      },
      deep: true,
    },
  },
  methods: {
    // 多选/单选切换
    toggleFilter(item, n) {
      if (item.multi) {
        const col = Array.isArray(item.col) ? [...item.col] : [item.col];
        if (n === "全部" || n === "不限") {
          item.col = [n];
        } else {
          const idx = col.indexOf(n);
          if (idx > -1) {
            col.splice(idx, 1);
            item.col = col.length ? col : [item.list[0]];
          } else {
            const allIdx = col.indexOf("全部");
            const buxianIdx = col.indexOf("不限");
            if (allIdx > -1) col.splice(allIdx, 1);
            if (buxianIdx > -1) col.splice(buxianIdx, 1);
            item.col = [...col, n];
          }
        }
      } else {
        item.col = n;
      }
    },
    // 搜索
    searchInput1() {
      this.patentList();
    },
    // 热点专利列表接口
    patentList() {
      const getColVal = (col) => {
        const val = Array.isArray(col) ? col : [col];
        const filtered = val.filter((v) => v !== "全部" && v !== "不限");
        if (filtered.length === 0) return null;
        return filtered.length === 1 ? filtered[0] : filtered.join(",");
      };
      //产权类型+交易类型+翻页筛选
      let data = {
        propertyCategory: mapPropertyCategoryForRequest(
          getColVal(this.shaiXuanList[0].col)
        ),
        projectDomain: getColVal(this.shaiXuanList[1].col),
        dealWay: getColVal(this.shaiXuanList[2].col),
        enterpriseId: this.jgId,
        ...this.page,
      };

      // 搜索框筛选
      if (this.input1 && this.input1 != "") {
        data.name = this.input1;
      }

      // 挂牌时间筛选
      let dataTime = this.shaiXuanList[3].col;
      if (dataTime == "一周内") {
        data.tiemEnd = this.$moment().format("x");
        data.timeBegin = this.$moment().subtract(7, "days").format("x");
      } else if (dataTime == "一月内") {
        data.tiemEnd = this.$moment().format("x");
        data.timeBegin = this.$moment().subtract(30, "days").format("x");
      } else if (dataTime == "自定义") {
        data.timeBegin = this.time1[0];
        data.tiemEnd = this.time1[1];
      }

      //挂牌价格
      let dataPrice = this.shaiXuanList[4].col;
      if (dataPrice == "自定义") {
        if (this.price1 <= this.price2) {
          data.priceLow = this.price1;
          data.priceHigh = this.price2;
        } else {
          data.priceLow = this.price2;
          data.priceHigh = this.price1;
        }
      } else if (dataPrice == "从高到低") {
        data.sortOrder = "desc";
        data.sortName = "floor_price";
      } else if (dataPrice == "从低到高") {
        data.sortOrder = "asc";
        data.sortName = "floor_price";
      }

      getRequest({ url: "/api/v1/markRelease/list", data }).then((res) => {
        // console.warn("什么列表", res);
        if (res.errcode == 200) {
          this.introduction = res.data;
          this.total = res.totalCount;
        }
      });
    },
    // 活跃企业列表接口
    jigouList() {
      //产权类型+交易类型+翻页筛选
      let data = {
        // page: 1,
        // size: 10,
      };

      getRequest({ url: "/api/v1/enterprise/recommend", data }).then((res) => {
        if (res.errcode == 200) {
          this.jgList = res.data;
        }
      });
    },
    // 活跃企业详情接口
    jigouDetails() {
      getRequest({ url: "/api/v1/enterprise/detail/" + this.jgId }).then(
        (res) => {
          if (res.errcode == 200) {
            this.jgObj = res.data;
          }
        }
      );
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    cardsZ() {
      if (this.cardsleft < 0) {
        this.cardsleft += this.cardwidth;
      }
    },
    cardsY() {
      if (this.cardsleft >= -(this.jgList.length - 2) * this.cardwidth) {
        this.cardsleft -= this.cardwidth;
      }
    },
  },
  created() {
    if (this.$route.query.value) {
      this.input1 = this.$route.query.value;
    }
    if (this.$route.query.jgId) {
      this.jgId = this.$route.query?.jgId;
      this.jigouDetails();
    }
    this.patentList();
    this.jigouList();
  },
};
</script>

<style lang="scss">
.ji_gou {
  background: #4080ff;
  height: 134px;
  margin-bottom: 80px;

  .ji_gou_1 {
    position: relative;
    bottom: -35px;
    box-shadow: 0px 6px 16px 0px rgba(78, 89, 105, 0.12);
  }
}

.seemore {
  width: 80%;
  margin: 0 auto;
  padding: 35px 0 150px;
  position: relative;

  .el-date-editor .el-range-separator {
    padding: 0;
  }

  .tui_jian_2 {
    background: #ffffff;
    border-radius: 0px 0px 8px 8px;
    border: 1px solid #e5e6eb;
    border-top: none;
    padding: 24px;

    .zuo,
    .you {
      width: 16px;
      height: 48px;
      background: #f2f3f5;
      border-radius: 2px 2px 2px 2px;
      color: #c9cdd4;
      cursor: pointer;
    }

    .cards {
      width: 92%;
      overflow: hidden;

      .cards_col {
        margin: 0 10px;
      }
    }
  }

  .tui_jian {
    margin-top: 80px;
    width: 100%;
    height: 60px;
    background: #f7f8fa;
    border-radius: 8px 8px 0px 0px;
    border: 1px solid #e5e6eb;
    padding: 0 24px;

    .cha_kan {
      font-size: 14px;
      font-weight: 400;
      color: #165dff;
      cursor: pointer;
    }

    .name {
      font-size: 18px;
      font-weight: 500;
      color: #1d2129;
    }
  }

  .fen_ye {
    margin-top: 48px;
  }

  .lie_biao {
    width: 100%;
  }

  .jie_guo {
    width: 100%;
    height: 60px;
    background: #f7f8fa;
    border-radius: 8px 8px 8px 8px;
    font-size: 14px;
    font-weight: 500;
    color: #4e5969;
    padding: 0 24px;

    span {
      color: #165dff;
    }

    .el-select {
      width: 106px;
    }
  }

  .shou_qi {
    width: 100%;
    position: relative;
    margin-bottom: 32px;

    img {
      width: 112px;
    }

    div {
      position: absolute;
      width: 112px;
      height: 26px;
      top: 0;
      left: 50%;
      margin-left: -56px;
      font-size: 14px;
      font-weight: 400;
      color: #1d2129;
      cursor: pointer;
    }
  }

  .shai_xuan {
    padding: 24px;
    width: 100%;
    border-radius: 12px 12px 12px 12px;
    opacity: 1;
    border: 1px solid #e5e6eb;

    .cad {
      font-size: 14px;
      line-height: 32px;
      font-weight: 400;
      margin-bottom: 15px;

      .name {
        color: #86909c;
        width: 60px;
        margin-right: 30px;
      }

      .col {
        margin-right: 24px;
        color: #1d2129;
        cursor: pointer;
      }

      .checked {
        color: #165dff;
      }
    }

    .title {
      font-size: 18px;
      line-height: 18px;
      font-weight: 500;
      color: #1d2129;
      padding-bottom: 16px;
      border-bottom: #e5e6eb solid 1px;
      margin-bottom: 16px;
    }
  }

  .crumbs {
    font-size: 12px;
    color: #86909c;
    margin-bottom: 35px;
  }

  .searchs {
    width: 70%;
    margin: 0 auto 55px;

    .tabs {
      font-size: 18px;
      font-weight: 500;
      color: #86909c;
      line-height: 18px;

      &>div {
        margin-left: 24px;
        cursor: pointer;

        img {
          margin-top: 16px;
        }
      }

      .checked {
        color: #165dff;
      }
    }

    .sou_suo {
      height: 52px;
      width: 100%;
      background: #f2f3f5;
      border-radius: 8px 8px 8px 8px;
      padding: 0 18px;

      input,
      el-input {
        flex: 1;
        font-size: 16px;
        border: none;
        outline: none;
        background: #f2f3f5;
      }
    }
  }
}
</style>
